import { Typography, useMediaQuery } from '@mui/material';
import silver from '../../assets/silver.json';
import diamond from '../../assets/diamond.json';
import ruby from '../../assets/ruby.json';
import gold from '../../assets/gold.json';
import hof from '../../assets/hof.json';
import mp from '../../assets/mp.json';
import wnd from '../../assets/treasure.json';
import { Player } from '@lottiefiles/react-lottie-player';
import profile from '../../assets/Export Profile.png';
import works from '../../assets/works.png';
import book from '../../assets/books.png';
import like from '../../assets/like.png';
import comment from '../../assets/comment.png';
import friend from '../../assets/friendsIcon.png';
import reacted from '../../assets/reacted.svg';
import dedicatedWork from '../../assets/dedicatedWork.png';
import React from 'react';
import contest from '../../assets/contests1.png';
import quest from '../../assets/Quest.png';
import view from '../../assets/view.png';

const Doc = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <div>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '48px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          textAlign: isMobile ? 'left' : 'center',
          marginLeft: isMobile ? '5%' : 0
        }}>
        🌟SCORE CARD GUIDE
      </Typography>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '14px' : '25px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '500',
          textAlign: isMobile ? 'left' : 'center',
          margin: '2% 7%'
        }}>
        Everything you do in this app helps you grow and shine. You earn points in FOUR different ways!
        <span> Let’s see how 👇👇👇</span>
      </Typography>

      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '35px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          textAlign: isMobile ? 'left' : 'center',
          marginLeft: isMobile ? '5%' : 0
        }}>
        ✨ Valuables (V)
      </Typography>
      <div>
        <div style={{ margin: isMobile ? '3% 5%' : '3% 10%', border: '2px solid grey', display: 'flex' }}>
          {/* Left Column */}

          <div style={{ flex: 1, borderRight: '2px solid grey' }}>
            {[
              { name: 'Valuables', icon: '' },
              { name: 'Silver', icon: silver },
              { name: 'Gold', icon: gold },
              { name: 'Ruby', icon: ruby },
              { name: 'Diamond', icon: diamond }
            ].map((item, index, arr) => (
              <div
                key={index}
                style={{
                  width: '100%',
                  backgroundColor: item.name === 'Valuables' ? ' rgba(0, 0, 0, 0.35)' : 'rgb(255,255,255,0.5)',
                  backdropFilter: 'blur(104px)',
                  padding: isMobile ? '4px 5%' : '20px 10%',
                  boxSizing: 'border-box',
                  borderBottom: index < arr.length - 1 ? '1px solid grey' : 'none',
                  display: 'flex'
                }}>
                <Player
                  autoplay
                  loop
                  src={item.icon}
                  style={{ width: isMobile ? '20px' : '40px', height: isMobile ? '20px' : '40px' }}
                />
                <Typography
                  style={{
                    fontFamily: 'Baloo2',
                    fontSize: isMobile ? '16px' : '28px',
                    color: 'rgba(255, 255, 255, 1)',
                    fontWeight: '800',
                    width: '100%',
                    marginLeft: isMobile ? '5%' : '10%'
                  }}>
                  {item.name}
                </Typography>
              </div>
            ))}
          </div>

          {/* Right Column */}
          <div style={{ flex: 1 }}>
            {[
              { points: 'Points' },
              { points: '+5 Points' },
              { points: '+10 Points' },
              { points: '+15 Points' },
              { points: '+20 Points' }
            ].map((item, index, arr) => (
              <div
                key={index}
                style={{
                  width: '100%',
                  backgroundColor: item.points === 'Points' ? ' rgba(0, 0, 0, 0.35)' : 'rgb(255,255,255,0.5)',
                  backdropFilter: 'blur(104px)',
                  padding: isMobile ? '4px 5%' : '20px 10%',
                  boxSizing: 'border-box',
                  borderBottom: index < arr.length - 1 ? '1px solid grey' : 'none'
                }}>
                <Typography
                  style={{
                    fontFamily: 'Baloo2',
                    fontSize: isMobile ? '16px' : '28px',
                    color: 'rgba(255, 255, 255, 1)',
                    fontWeight: '800',
                    width: '100%',
                    marginLeft: '50px'
                  }}>
                  {item.points}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '35px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          textAlign: isMobile ? 'left' : 'center',
          marginLeft: isMobile ? '5%' : 0
        }}>
        🎖️ Badges (B)
      </Typography>
      <div>
        <div style={{ margin: isMobile ? '3% 5%' : '3% 10%', border: '2px solid grey', display: 'flex' }}>
          {/* Left Column */}

          <div style={{ flex: 1, borderRight: '2px solid grey' }}>
            {[
              { name: 'Badges', icon: '' },
              { name: 'Masterpiece', icon: mp },
              { name: 'Treasure', icon: wnd },
              { name: 'Hall of Fame', icon: hof }
            ].map((item, index, arr) => (
              <div
                key={index}
                style={{
                  width: '100%',
                  backgroundColor: item.name === 'Badges' ? ' rgba(0, 0, 0, 0.35)' : 'rgb(255,255,255,0.5)',
                  backdropFilter: 'blur(104px)',
                  padding: isMobile ? '4px 5%' : '20px 10%',
                  boxSizing: 'border-box',
                  borderBottom: index < arr.length - 1 ? '1px solid grey' : 'none',
                  display: 'flex'
                }}>
                <Player
                  autoplay
                  loop
                  src={item.icon}
                  style={{ width: isMobile ? '20px' : '40px', height: isMobile ? '20px' : '40px' }}
                />
                <Typography
                  style={{
                    fontFamily: 'Baloo2',
                    fontSize: isMobile ? '16px' : '28px',
                    color: 'rgba(255, 255, 255, 1)',
                    fontWeight: '800',
                    width: '100%',
                    marginLeft: isMobile ? '5%' : '10%'
                  }}>
                  {item.name}
                </Typography>
              </div>
            ))}
          </div>

          {/* Right Column */}
          <div style={{ flex: 1 }}>
            {[{ points: 'Points' }, { points: '+10 Points' }, { points: '+15 Points' }, { points: '+20 Points' }].map(
              (item, index, arr) => (
                <div
                  key={index}
                  style={{
                    width: '100%',
                    backgroundColor: item.points === 'Points' ? ' rgba(0, 0, 0, 0.35)' : 'rgb(255,255,255,0.5)',
                    backdropFilter: 'blur(104px)',
                    padding: isMobile ? '4px 5%' : '20px 10%',
                    boxSizing: 'border-box',
                    borderBottom: index < arr.length - 1 ? '1px solid grey' : 'none'
                  }}>
                  <Typography
                    style={{
                      fontFamily: 'Baloo2',
                      fontSize: isMobile ? '16px' : '28px',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: '800',
                      width: '100%',
                      marginLeft: '50px'
                    }}>
                    {item.points}
                  </Typography>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '35px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          textAlign: isMobile ? 'left' : 'center',
          margin: isMobile ? '5% 5%' : '3% 0'
        }}>
        🧩 The 4 Magical Score Types
      </Typography>

      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '16px' : '28px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          width: '100%',
          marginLeft: isMobile ? '5%' : '20%'
        }}>
        🔹 Activity Score
        {!isMobile && (
          <span style={{ fontWeight: '400' }}> - 🛠️ Activity Scores are created by winning Quests and Contests.</span>
        )}
      </Typography>
      {isMobile && (
        <Typography
          style={{
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '16px' : '28px',
            color: 'rgba(255, 255, 255, 1)',
            fontWeight: '500',
            width: '100%',
            marginLeft: isMobile ? '5%' : '10%'
          }}>
          🛠️ Activity Scores are created by winning Quests and Contests.
        </Typography>
      )}

      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '16px' : '28px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          width: '100%',
          marginLeft: isMobile ? '5%' : '20%'
        }}>
        🔹 Benevolence Score
        {!isMobile && (
          <span style={{ fontWeight: '400' }}> - 💖 For being friendly, liking, commenting, reacting.</span>
        )}
      </Typography>
      {isMobile && (
        <Typography
          style={{
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '16px' : '28px',
            color: 'rgba(255, 255, 255, 1)',
            fontWeight: '500',
            width: '100%',
            marginLeft: isMobile ? '5%' : '10%'
          }}>
          💖 For being friendly, liking, commenting, reacting.
        </Typography>
      )}
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '16px' : '28px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          width: '100%',
          marginLeft: isMobile ? '5%' : '20%'
        }}>
        🔹 Achievement Score
        {!isMobile && (
          <span style={{ fontWeight: '400' }}> - 🏅 Achievement Scores are created by unlocking new clubs.</span>
        )}
      </Typography>
      {isMobile && (
        <Typography
          style={{
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '16px' : '28px',
            color: 'rgba(255, 255, 255, 1)',
            fontWeight: '500',
            width: '100%',
            marginLeft: isMobile ? '5%' : '10%'
          }}>
          🏅 Achievement Scores are created by unlocking new clubs.
        </Typography>
      )}
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '16px' : '28px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          width: '100%',
          marginLeft: isMobile ? '5%' : '20%'
        }}>
        🔹 Popularity Score
        {!isMobile && (
          <span style={{ fontWeight: '400' }}> - 🌟 For getting love from others, likes, views, comments.</span>
        )}
      </Typography>
      {isMobile && (
        <Typography
          style={{
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '16px' : '28px',
            color: 'rgba(255, 255, 255, 1)',
            fontWeight: '500',
            width: '100%',
            marginLeft: isMobile ? '5%' : '10%'
          }}>
          🌟 For getting love from others, likes, views, comments.
        </Typography>
      )}

      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '35px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          width: '100%',
          margin: isMobile ? '5% 5%' : '5% 0',
          textAlign: isMobile ? 'left' : 'center'
        }}>
        🔹 Activity Score
      </Typography>
      <div
        style={{
          margin: isMobile ? '3% 5%' : '3% 10%',
          border: '2px solid grey'
        }}>
        {[
          { name: 'Activities', icon: '', points: 'Points' },
          { name: 'Profile Completion', icon: profile, points: '+10 Points' },
          { name: 'Featured Work', icon: works, points: 'V/B' },
          { name: 'Featured Book', icon: book, points: 'V/B' }
        ].map((item, index, arr) => (
          <div
            key={index}
            style={{
              display: 'flex',
              borderBottom: index < arr.length - 1 ? '1px solid grey' : 'none',
              backgroundColor: item.name === 'Activities' ? 'rgba(0, 0, 0, 0.35)' : 'rgba(255,255,255,0.5)',
              backdropFilter: 'blur(104px)',
              padding: isMobile ? '4px 5%' : '20px 10%',
              boxSizing: 'border-box'
            }}>
            {/* Left Column Item */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                borderRight: '2px solid grey', // <-- add right border here!
                paddingRight: isMobile ? '5%' : '10%', // optional: add right padding
                boxSizing: 'border-box'
              }}>
              {item.icon && (
                <img
                  alt="icon"
                  src={item.icon}
                  style={{
                    width: isMobile ? '20px' : '40px',
                    height: isMobile ? '20px' : '40px'
                  }}
                />
              )}
              <Typography
                style={{
                  fontFamily: 'Baloo2',
                  fontSize: isMobile ? '16px' : '28px',
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: item.name === 'Activities' ? 800 : '500',
                  marginLeft: item.icon ? (isMobile ? '5%' : '10%') : 0
                }}>
                {item.name}
              </Typography>
            </div>

            {/* Right Column Item */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: isMobile ? '5%' : '10%', // optional: add left padding
                boxSizing: 'border-box'
              }}>
              <Typography
                style={{
                  fontFamily: 'Baloo2',
                  fontSize: isMobile ? '16px' : '28px',
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: item.points === 'Points' ? 800 : '500'
                }}>
                {item.points}
              </Typography>
            </div>
          </div>
        ))}
      </div>

      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '35px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          width: '100%',
          margin: isMobile ? '5% 5%' : '5% 0',
          textAlign: isMobile ? 'left' : 'center'
        }}>
        🔹 Benevolence Score
      </Typography>
      <div
        style={{
          margin: isMobile ? '3% 5%' : '3% 10%',
          border: '2px solid grey'
        }}>
        {[
          { name: 'Benevolence', icon: '', points: 'Points' },
          { name: 'Liked a Work/Book', icon: like, points: '+0.001 Points' },
          { name: 'commented a Work/Book', icon: comment, points: '+0.001 Points' },
          { name: 'Reacted a Work/Book', icon: reacted, points: '+0.001 Points' },
          { name: 'Sent a Friend Request', icon: friend, points: '+0.001 Points' },
          { name: 'Dedicated Work ', icon: dedicatedWork, points: '+0.1 Points' }
        ].map((item, index, arr) => (
          <div
            key={index}
            style={{
              display: 'flex',
              borderBottom: index < arr.length - 1 ? '1px solid grey' : 'none',
              backgroundColor: item.name === 'Benevolence' ? 'rgba(0, 0, 0, 0.35)' : 'rgba(255,255,255,0.5)',
              backdropFilter: 'blur(104px)',
              padding: isMobile ? '4px 5%' : '20px 10%',
              boxSizing: 'border-box'
            }}>
            {/* Left Column Item */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                borderRight: '2px solid grey', // <-- add right border here!
                paddingRight: isMobile ? '5%' : '10%', // optional: add right padding
                boxSizing: 'border-box'
              }}>
              {item.icon && (
                <img
                  alt="icon"
                  src={item.icon}
                  style={{
                    width: isMobile ? '20px' : '40px',
                    height: isMobile ? '20px' : '40px'
                  }}
                />
              )}
              <Typography
                style={{
                  fontFamily: 'Baloo2',
                  fontSize: isMobile ? '16px' : '28px',
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: item.name === 'Activities' ? 800 : '500',
                  marginLeft: item.icon ? (isMobile ? '5%' : '10%') : 0
                }}>
                {item.name}
              </Typography>
            </div>

            {/* Right Column Item */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: isMobile ? '5%' : '10%', // optional: add left padding
                boxSizing: 'border-box'
              }}>
              <Typography
                style={{
                  fontFamily: 'Baloo2',
                  fontSize: isMobile ? '16px' : '28px',
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: item.points === 'Points' ? 800 : '500'
                }}>
                {item.points}
              </Typography>
            </div>
          </div>
        ))}
      </div>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '35px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          width: '100%',
          margin: isMobile ? '5% 5%' : '5% 0',
          textAlign: isMobile ? 'left' : 'center'
        }}>
        🔹 Achievement Score
      </Typography>
      <div
        style={{
          margin: isMobile ? '3% 5%' : '3% 10%',
          border: '2px solid grey'
        }}>
        {[
          { name: 'Achievement', icon: '', points: 'Points' },
          { name: 'Joined a Contest', icon: contest, points: '+10 Points' },
          { name: 'Won a Contest', icon: contest, points: 'Based on Contest' },
          { name: 'completed a Quest', icon: quest, points: 'Based on Quest' }
        ].map((item, index, arr) => (
          <div
            key={index}
            style={{
              display: 'flex',
              borderBottom: index < arr.length - 1 ? '1px solid grey' : 'none',
              backgroundColor: item.name === 'Achievement' ? 'rgba(0, 0, 0, 0.35)' : 'rgba(255,255,255,0.5)',
              backdropFilter: 'blur(104px)',
              padding: isMobile ? '4px 5%' : '20px 10%',
              boxSizing: 'border-box'
            }}>
            {/* Left Column Item */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                borderRight: '2px solid grey', // <-- add right border here!
                paddingRight: isMobile ? '5%' : '10%', // optional: add right padding
                boxSizing: 'border-box'
              }}>
              {item.icon && (
                <img
                  alt="icon"
                  src={item.icon}
                  style={{
                    width: isMobile ? '20px' : '40px',
                    height: isMobile ? '20px' : '40px'
                  }}
                />
              )}
              <Typography
                style={{
                  fontFamily: 'Baloo2',
                  fontSize: isMobile ? '16px' : '28px',
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: item.name === 'Activities' ? 800 : '500',
                  marginLeft: item.icon ? (isMobile ? '5%' : '10%') : 0
                }}>
                {item.name}
              </Typography>
            </div>

            {/* Right Column Item */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: isMobile ? '5%' : '10%', // optional: add left padding
                boxSizing: 'border-box'
              }}>
              <Typography
                style={{
                  fontFamily: 'Baloo2',
                  fontSize: isMobile ? '16px' : '28px',
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: item.points === 'Points' ? 800 : '500'
                }}>
                {item.points}
              </Typography>
            </div>
          </div>
        ))}
      </div>

      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '35px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '800',
          width: '100%',
          margin: isMobile ? '5% 5%' : '5% 0',
          textAlign: isMobile ? 'left' : 'center'
        }}>
        🔹 Popularity Score
      </Typography>
      <div
        style={{
          margin: isMobile ? '3% 5%' : '3% 10%',
          border: '2px solid grey'
        }}>
        {[
          { name: 'Popularity', icon: '', points: 'Points' },
          { name: 'Work/Book viewed', icon: view, points: '+0.001 Points' },
          { name: 'Work/Book liked', icon: like, points: '+0.001 Points' },
          { name: 'Work/Book commented', icon: comment, points: '+0.001 Points' },
          { name: 'Work/Book reacted', icon: reacted, points: '+0.001 Points' },
          { name: 'Receieved Friend Request ', icon: friend, points: '+0.001 Points' },
          { name: 'Dedicated in a Work ', icon: dedicatedWork, points: '+0.1 Points' }
        ].map((item, index, arr) => (
          <div
            key={index}
            style={{
              display: 'flex',
              borderBottom: index < arr.length - 1 ? '1px solid grey' : 'none',
              backgroundColor: item.name === 'Popularity' ? 'rgba(0, 0, 0, 0.35)' : 'rgba(255,255,255,0.5)',
              backdropFilter: 'blur(104px)',
              padding: isMobile ? '4px 5%' : '20px 10%',
              boxSizing: 'border-box'
            }}>
            {/* Left Column Item */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                borderRight: '2px solid grey', // <-- add right border here!
                paddingRight: isMobile ? '5%' : '10%', // optional: add right padding
                boxSizing: 'border-box'
              }}>
              {item.icon && (
                <img
                  alt="icon"
                  src={item.icon}
                  style={{
                    width: isMobile ? '20px' : '40px',
                    height: isMobile ? '20px' : '40px'
                  }}
                />
              )}
              <Typography
                style={{
                  fontFamily: 'Baloo2',
                  fontSize: isMobile ? '16px' : '28px',
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: item.name === 'Activities' ? 800 : '500',
                  marginLeft: item.icon ? (isMobile ? '5%' : '10%') : 0
                }}>
                {item.name}
              </Typography>
            </div>

            {/* Right Column Item */}
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: isMobile ? '5%' : '10%', // optional: add left padding
                boxSizing: 'border-box'
              }}>
              <Typography
                style={{
                  fontFamily: 'Baloo2',
                  fontSize: isMobile ? '16px' : '28px',
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: item.points === 'Points' ? 800 : '500'
                }}>
                {item.points}
              </Typography>
            </div>
          </div>
        ))}
      </div>

      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '12px' : '25px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '500',
          width: '100%',
          margin: isMobile ? '5% 5% 0 5% ' : 0,
          textAlign: isMobile ? 'left' : 'center'
        }}>
        📢 Keep creating, stay kind, and share your sparkle with the world!
      </Typography>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '12px' : '25px',
          color: 'rgba(255, 255, 255, 1)',
          fontWeight: '500',
          width: '100%',
          margin: isMobile ? '0 5% 10% 5%' : '0 0 10% 0',
          textAlign: isMobile ? 'left' : 'center'
        }}>
        Every little action brings you closer to greatness
      </Typography>
    </div>
  );
};
export default Doc;
